// AgentRequestsPanel — Phase 3 consolidated agent-side surface.
//
// FLAW 1 fix (2026-05-16): swapped the always-exposed
// <PaymentSettingsPanel mode="subagent" /> form for the new compact
// <PaymentSettingsCard audience="subagent" /> read-only summary +
// Edit-modal. Identical to the swap on PlayerRequestsPanel; same
// PATCH endpoint, same /subagent-qr upload path — the form just lives
// behind a single Edit button now.
//
// Composition:
//   1. <PaymentSettingsCard audience="subagent" />
//        — sub-agent-facing read-only QR/UPI/contact summary card
//        — same backend endpoints as before (admin/payment-settings)
//   2. <AdminMoneyPanel />
//        — auto-detects scope='agents' from URL (URL contains '/agents')
//        — internal in/out direction toggle, Pending/History sub-tabs,
//          ApprovalEditModal flow — unchanged from the /finance era.

import PaymentSettingsCard from '../../components/PaymentSettingsCard';
import AdminMoneyPanel from '../finance/AdminMoneyPanel';

export default function AgentRequestsPanel() {
  return (
    <div className="space-y-4">
      <PaymentSettingsCard audience="subagent" />
      <AdminMoneyPanel />
    </div>
  );
}
